/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextActionCheckIcon16Light } from './TextActionCheckIcon16Light';
import { TextActionCheckIcon16Regular } from './TextActionCheckIcon16Regular';
import { TextActionCheckIcon16Solid } from './TextActionCheckIcon16Solid';
import { TextActionCheckIcon20Light } from './TextActionCheckIcon20Light';
import { TextActionCheckIcon20Regular } from './TextActionCheckIcon20Regular';
import { TextActionCheckIcon20Solid } from './TextActionCheckIcon20Solid';
import { TextActionCheckIcon24Regular } from './TextActionCheckIcon24Regular';
import { TextActionCheckIcon24Solid } from './TextActionCheckIcon24Solid';
import { TextActionCheckIcon32Regular } from './TextActionCheckIcon32Regular';
import { TextActionCheckIcon64Regular } from './TextActionCheckIcon64Regular';
var sizes = {
    16: {
        light: TextActionCheckIcon16Light,
        regular: TextActionCheckIcon16Regular,
        solid: TextActionCheckIcon16Solid,
    },
    20: {
        light: TextActionCheckIcon20Light,
        regular: TextActionCheckIcon20Regular,
        solid: TextActionCheckIcon20Solid,
    },
    24: {
        regular: TextActionCheckIcon24Regular,
        solid: TextActionCheckIcon24Solid,
    },
    32: {
        regular: TextActionCheckIcon32Regular,
    },
    64: {
        regular: TextActionCheckIcon64Regular,
    },
};
export var TextActionCheckIcon = forwardRef('TextActionCheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
